import { Instance, types } from "mobx-state-tree";
import { AnyUserReferenceType } from "../../../users/AnyUserReferenceType";
import { ChatItemStatus } from "../ChatItemStatus";
import { ChatItemType } from "../ChatItemType";
import { TextChatItem } from "./TextChatItem";

/**
 * GDPR request
 */
export const ContactEnquiryChatItem = types.compose(
  "ContactEnquiryChatItem",
  TextChatItem,
  types.model({
    type: types.literal(ChatItemType.ContactEnquiry),
    user: AnyUserReferenceType,
    // FIXME: only because chat item group requires it
    status: types.optional(types.literal(ChatItemStatus.SENT), ChatItemStatus.SENT)
  })
);

export interface IContactEnquiryChatItem extends Instance<typeof ContactEnquiryChatItem> {}
